import React from 'react';

const STEPS = ['본인 인증', '데이터 수집', 'AI 분석'];

export default function MyDataProgressSteps({ current }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0, padding: '16px 0' }}>
      {STEPS.map((label, i) => {
        const done = i < current;
        const active = i === current;
        const linkActive = done || active;
        return (
          <React.Fragment key={label}>
            {i > 0 && (
              <div style={{
                flex: '1 1 0', maxWidth: 48, height: 2,
                background: linkActive ? '#3498db' : '#e5e7eb',
              }} />
            )}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 40 }}>
              <div style={{
                width: 28, height: 28, borderRadius: '50%',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 13, fontWeight: 600,
                background: done ? '#3498db' : active ? '#3498db' : '#e5e7eb',
                color: done || active ? '#fff' : '#6b7280',
                transition: 'background 0.2s',
              }}>
                {done ? '✓' : i + 1}
              </div>
              <span style={{
                marginTop: 4, fontSize: 11,
                color: done || active ? '#3498db' : '#6b7280',
                fontWeight: active ? 700 : 400,
              }}>
                {label}
              </span>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}
